export const ENUMS = {
  UNLIMITED: '不限',
  MANUAL: '首选媒体',
  UNIVERSAL_SMART: '通投智选',
  INVENTORY_FEED: '今日头条',
  INVENTORY_VIDEO_FEED: '西瓜视频',
  INVENTORY_AWEME_FEED: '抖音短视频',
  INVENTORY_TOMATO_NOVEL: '番茄小说',
  INVENTORY_UNION_SLOT: '穿山甲',
  UNION_BOUTIQUE_GAME: 'ohayoo精品游戏',
  INVENTORY_SEARCH: '搜索计划',
  AUDIENCE: '定向或排除人群',
  REGION: '按省市',
  GENDER_MALE: '男',
  GENDER_FEMALE: '女',
  AGE_BETWEEN_18_23: '18-23岁',
  AGE_BETWEEN_24_30: '24-30岁',
  AGE_BETWEEN_31_40: '31-40岁',
  AGE_BETWEEN_41_49: '41-49岁',
  AGE_ABOVE_50: '大于等于50岁',
  AGE_BETWEEN_18_19: '18-29岁',
  AGE_BETWEEN_20_23: '20-23岁',
  AGE_BETWEEN_31_35: '31-35岁',
  AGE_BETWEEN_36_40: '36-40岁',
  AGE_BETWEEN_41_45: '41-45岁',
  AGE_BETWEEN_46_50: '46-50岁',
  AGE_BETWEEN_51_55: '51-55岁',
  AGE_BETWEEN_56_59: '56-59岁',
  AGE_ABOVE_60: '大于等于60岁',
  RECOMMEND: '系统推荐',
  CUSTOM: '自定义',
  ANDROID: 'Android',
  IOS: 'IOS',
  HARMONY: '鸿蒙',
  NO_EXCLUDE: '不限制',
  PROMOTION: '计划',
  PROJECT: '推广项目',
  ADVERTISER: '计划账户',
  APP: '应用',
  CUSTOMER: '客户',
  ORGANIZATION: '组织',
  DEVICE: '设备类型',
  MOBILE: '智能手机',
  PAD: '平板',
  OFF: '关闭',
  ON: '开启',
  NONE: '不限',
  WIFI: 'WIFI',
  '2G': '2G',
  '3G': '3G',
  '4G': '4G',
  '5G': '5G',
  GAME: '游戏优质媒体',
  CARRIER_TYPE_0: '不限',
  CARRIER_TYPE_MOBILE: '移动',
  CARRIER_TYPE_UNICOM: '联通',
  CARRIER_TYPE_TELCOM: '电信',
  0: '不限',
  WITH_IN_A_MONTH: '一个月以内',
  ONE_MONTH_2_THREE_MONTH: '一个月到三个月',
  THREE_MONTH_EAILIER: '三个月或更早',
  BRAND_TYPE_UNLIMITED: '不限',
  BRAND_TYPE_CUSTOM: '按手机品牌'
}
